// extracted by mini-css-extract-plugin
export default {"skeletWrapper":"BonusesSkelet_skeletWrapper--g4a","skeletItem":"BonusesSkelet_skeletItem--e6n"};